import { Location } from "@angular/common";
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranscriptionService } from './../../../core/services/transcription.service';
import { TranscriptionResponse, TranscriptionDataResponse } from './../../../Models/transcriptionModelR/transcription-response';
import { DashboardService } from './../../../core/services/dashboard.service';
import { ModalEditionsMeetingComponent } from '../modal-editions-meeting/modal-editions-meeting.component';
import { ModalNotificationComponent } from '../modal-notification/modal-notification.component';
import { GlobalComponents } from '../global-constants';
import { UserService } from './../../../core/services/user.service';
import { Router } from "@angular/router";
import { USE_DEFAULT_LANG } from "@ngx-translate/core";
import { DatePipe } from '@angular/common';
import { AudioPlayerPortalService } from "src/app/core/portals/audio-player-portal/audio-player-portal.service";
import { AudioService } from "src/app/core/services/audio.service";
import { Language } from '../../../models/languageModel/language';
import * as fileSaver from 'file-saver';

@Component({
  selector: "app-transcription-module",
  templateUrl: "./transcription-module.component.html",
  styleUrls: ["./transcription-module.component.scss"],
  providers: [DatePipe],
})

@Input()
export class TranscriptionModuleComponent implements OnInit {
  public transcription: Observable<TranscriptionResponse>;
  public dataResult: TranscriptionResponse[];
  public transcripData: TranscriptionDataResponse[];
  public title: string;
  public idTrans: number;
  public start: any;
  public dateCreation: string;
  showAdvancedFilters = false;
  idMeet: number;
  showFloor: boolean = true; //default
  showEsp: boolean = false;
  showEng: boolean = false;
  showFra: boolean = false;
  showPor: boolean = false; // hidden
  showTrans: boolean = true;
  finding: boolean = true;
  idiomList: any = ["Floor", "Español", "Inglés", "Francés", "Portugues"];
  idiomForm = new FormControl();
  
  public SEC: boolean = false;
  public STB: boolean = false;
  public Directory: boolean = false;
  public NoShowSteering: boolean = false;
  public SteeringCommittees: string[] = ['Steering Committee','IDB Steering Committee']
  public PresidentCommittees: string[] = ["President's Committee"]

  @ViewChild('230') targetEl: ElementRef;

  lastMeeting: any;
  lastLang: string;
  public language = "Floor";
  
  constructor(private active: ActivatedRoute,
              private dialog: MatDialog,
              private _location: Location,
              private serviceDashboard: DashboardService,
              private serviceTranscription: TranscriptionService,
              private serviceUsers: UserService,
              private router: Router,
              private audioPlayerService: AudioPlayerPortalService,
              private serviceAudio: AudioService,
              public datepipe: DatePipe,) {}

  stbDisplayedColumns = ["transcription_Text"];

  get displayedColumns(): string[] {
    return this.filterTableColumns(this.stbDisplayedColumns);
  }

  filterTableColumns(columns: string[]): string[] {
    return columns.filter((column: string) => {
      if (!this.showAdvancedFilters) {
        const acceptedColumns = ["transcription_Text"];
        return acceptedColumns.includes(column);
      } else {
        return column;
      }
    });
  }

  async inicial(idMeeting) {
    await this.getUserRoles()
    this.idiomForm.setValue("Floor");
    this.transcription = this.serviceDashboard.getTranscriptionMeeting(idMeeting, true);
    await this.transcription.toPromise().then((resp) => {
      console.log('this.NoShowSteering')
      if(this.NoShowSteering && this.SteeringCommittees.includes(resp.topic)){
        this.router.navigate(["/app/access"]);
      }
      if(!this.NoShowSteering && this.PresidentCommittees.includes(resp.topic)){
        this.router.navigate(["/app/access"]);
      }
      this.title = resp.topic;
      this.dateCreation = resp.dateCreation.toString().replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3");
      const us = [];
      resp.data.forEach((element) => {
        us.push({
          transcriptionId: element.transcriptionId,
          orador: element.orador,
          modifyBy: element.modifyBy,
          dateModify: element.dateModify,
          transcription_Text: element.transcriptionText,
          versionNumber: element.versionNumber,
          wordCount: element.wordCount,
          dateCreation: element.dateCreation,
          startTrack: element.startTrack,
          endTrack: element.endTrack,
          sentenceId: element.sentenceId,
          transcriptionEsp: element.transcriptionEsp,
          transcriptionEng: element.transcriptionEng,
          transcriptionFra: element.transcriptionFra,
          transcriptionPor: element.transcriptionPor,
          directory: element.directory,
          drEventId: element.drEventId,
          drRecId: element.drRecId,
        });
      }); 
      this.dataResult = us;
    }, (error) => {
      this.finding = false;
      this.notificationModal(GlobalComponents.notSuccess);
    });
  }

  ngOnInit(): void {
    var id = this.active.snapshot.paramMap.get("idMeeting");
    var trans = this.active.snapshot.paramMap.get("idTranscription");
    var start = this.active.snapshot.paramMap.get("start");
    this.idMeet = Number(id);
    this.idTrans = Number(trans);
    this.start = start;

    this.inicial(id).then(() => {
      this.finding = false;
      
      setTimeout(() => {
        if(Number(this.idTrans) > 0) this.scrollInMarkOfTime();
      }, 500);
    });
  }

  scrollInMarkOfTime() {

    let keepGoing = true;

    this.dataResult.forEach(meeting => {
      if(keepGoing == true && new Date(this.start).getTime() >= new Date(meeting['startTrack']).getTime()
      && new Date(this.start).getTime() <= new Date(meeting['endTrack']).getTime()) {
  
        const elemento = document.getElementById(`id-${meeting['startTrack']}`);
        elemento.scrollIntoView();

        keepGoing = false;
      }
      
    });

    let _keepGoing = true;

    this.dataResult.forEach(meeting => {
      if(_keepGoing == true && new Date(this.start).getTime() >= new Date(meeting['startTrack']).getTime()
      && new Date(this.start).getTime() <= new Date(meeting['endTrack']).getTime()) {

        const parrafo = document.getElementById(`p-${meeting['startTrack']}`);
        parrafo.style.fontWeight = 'Bold';
        parrafo.style.color = "#d3701f"

        _keepGoing = false;
      }
    });

  }

  volverHome() {
    this._location.back();
  }

  form = new FormGroup({
    selectIdiom: new FormControl("", Validators.required),
  });

  get f() {
    return this.form.controls;
  }
  
  submit() {
  }

  changeShow(e) {
    this.language = e.value;

    if (e.value == "Español") {
      this.showFloor = false;
      this.showEsp = true;
      this.showEng = false;
      this.showFra = false;
      this.showPor = false;
      this.showTrans = false; //
    }
    if (e.value === "Inglés") {
      this.showFloor = false;
      this.showEsp = false;
      this.showEng = true;
      this.showFra = false;
      this.showPor = false;
      this.showTrans = false; //
    }
    if (e.value == "Floor") {
      this.showFloor = true;
      this.showEsp = false;
      this.showEng = false;
      this.showFra = false;
      this.showPor = false;
      this.showTrans = true;
    }
    if (e.value == "Francés") {
      this.showFloor = false;
      this.showEsp = false;
      this.showEng = false;
      this.showFra = true;
      this.showPor = false;
      this.showTrans = false; //
    }
    if (e.value == "Portugues") {
      this.showFloor = false;
      this.showEsp = false;
      this.showEng = false;
      this.showFra = false;
      this.showPor = true;
      this.showTrans = false; //
    }
  }

  openModalEditions() {
    const modalRef = this.dialog.open(ModalEditionsMeetingComponent, {
      width: "500px",
      maxHeight: "750px",
    });
    modalRef.componentInstance.meetingId = this.idMeet;

    modalRef.afterClosed().subscribe((value) => {
      if(value != "") {
        this.finding= true;
        this.getMeetingVersion(this.idMeet, value);
      } 
    });
  }

  getMeetingVersion(idMeet: number, value: any) {
    this.serviceTranscription.getTranscriptionsMeetingVersion(idMeet,value).toPromise()
    .then((resp) => {
      if(this.NoShowSteering && this.SteeringCommittees.includes(resp.topic)){
        this.router.navigate(["/app/access"]);
      }
      if(!this.NoShowSteering && this.PresidentCommittees.includes(resp.topic)){
        this.router.navigate(["/app/access"]);
      }
      this.title = resp.topic;
      let newDate = new Date(resp.dateCreation);
      this.dateCreation = newDate.toString().replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3");;
      const us = [];
      resp.data.forEach((element) => {
        us.push({
          transcriptionId: element.transcriptionId,
          orador: element.orador,
          modifyBy: element.modifyBy,
          dateModify: element.dateModify,
          transcription_Text: element.transcriptionText,
          versionNumber: element.versionNumber,
          wordCount: element.wordCount,
          dateCreation: element.startTrack,
          sentenceId: element.sentenceId,
          transcriptionEsp: element.transcriptionEsp,
          transcriptionEng: element.transcriptionEng,
          transcriptionFra: element.transcriptionFra,
          transcriptionPor: element.transcriptionPor,
          directory: element.directory,
          drEventId: element.drEventId,
          drRecId: element.drRecId,
        });
      });
      this.finding = false;
      this.dataResult = us;
    }, (error) => {
      this.finding = false;
      this.notificationModal(GlobalComponents.notSuccess);
    });
  }

  notificationModal(message: string){
    const dialogConfig = new MatDialogConfig();    
    dialogConfig.data = {
      message: message,
      valor:10
    }
    const modalRef = this.dialog.open(ModalNotificationComponent, dialogConfig);
  }

  async openModalAudio(meeting) {

    if(this.language == "Floor") {
      this.lastLang = "Flo";
    } else if (this.language == "Español") {
      this.lastLang = "Spa";
    } else if(this.language == "Inglés") {
      this.lastLang = "Eng";
    } else {
      this.lastLang = "Flo";
    }
    
    // this.lastMeeting = this.idMeet;

    this.audioPlayerService.attach({ title: this.title, startTime: '', endTime: '', link: '' })

    await this.serviceAudio.getAudioMeeting(meeting.drRecId, meeting.drEventId, this.lastLang).then(audio => {
      this.audioPlayerService.attach({ title: this.title, startTime: '', endTime: '', link: audio });
    })
  }

  async getUserRoles(){
    await this.serviceUsers.getRoles().toPromise().then((resp) => {
      if(resp.roles != null){
        resp.roles.forEach((element) => {
          if (element.includes('AV:Access to all Board meeting recordings except Steering Committee')){
            console.log('Assign Role Transcription')
            this.NoShowSteering = true
          }
          if(element.includes('SEC_Minutes_Officer') || element.includes('SEC_Minutes_Officers')){
            this.STB = true;
          }
          else if(element.includes('Recording Searchers')){
            this.SEC = true;
          }
          else if(element.includes('directory')){
            this.Directory = true;
          }
        });
      }else{
        this.checkRol();
      }      
    }, (err) => {
      this.finding = false;
      this.notificationModal(GlobalComponents.notSuccess);
    });    
  }

  checkRol() {
    if (!this.STB && !this.SEC && !this.Directory) {
      this.router.navigate(["/app/access"]);
    }
  }

  DownloadPdf(meetingId: number) {
    let currentLanguage: Language = JSON.parse(localStorage.getItem('languaje'));
    var languageId: number;
    if( currentLanguage.code == "es"){
      languageId = 1;
    }
    else{
      languageId = 2;
    }

    this.serviceTranscription.getPdf(meetingId, languageId).toPromise()
    .then((response) => {      
      let tm = "";
      if(languageId == 1){
        tm = "_TranscripciónDeReunión_";
      }
      else{
        tm = "_MeetingTranscription_";
      }

      const blob = new Blob([response], { type: response.type });
      fileSaver.saveAs(blob, this.datepipe.transform(Date.now(), 'yyyyMMddHHmmss') + tm + meetingId + ".pdf")

      this.dialog.closeAll();
    }, (error) => {
      this.notificationModal(GlobalComponents.notSuccess);
    });
  }

  DownloadWord(meetingId: number) {
    let currentLanguage: Language = JSON.parse(localStorage.getItem('languaje'));
    var languageId :number;
    if(currentLanguage.code == "es"){
      languageId = 1;
    }
    else{
      languageId = 2;
    }
    
    this.serviceTranscription.getWord(meetingId, languageId).toPromise()
    .then((response) => {

      let tm = "";
      if(languageId == 1){
        tm = "_TranscripciónDeReunión_";
      }
      else{
        tm = "_MeetingTranscription_";
      }

      const blob = new Blob([response], { type: response.type });
      fileSaver.saveAs(blob, this.datepipe.transform(Date.now(), 'yyyyMMddHHmmss') + tm + meetingId + ".docx")
        
      this.dialog.closeAll();
    }, (error) => {
      this.notificationModal(GlobalComponents.notSuccess);
    });
  }
}
